import React from 'react';

const Other = (props) => {
  return <div>Other</div>;
};

export default Other;
